export const VALUE_IF_ABSENT = '-';
export const ARRAY_IF_ABSENT = ['-', '-', '-'];
export const ITEM = 'item';
export const RECEPTACLE = 'receptacle';
export const DESPATCH = 'despatch';
export const CONSIGNMENT = 'consignment';
